import { Api } from '@/Api';
import { useDebug } from '@/composables/useDebug';
import { defineStore } from 'pinia';

const { debug } = useDebug('RequestContentStore');

export interface RequestContentItem {
  id: string;
  slug?: string;
  name: string;
  message: string;
  customId?: string;
  requestLink?: string;
  collectionId?: string;
}

export interface RequestContentState {
  list: RequestContentItem[];
  loading: boolean;
}

export const useRequestContentStore = defineStore('requestContentStore', {
  state: (): RequestContentState => ({
    list: [],
    loading: false,
  }),
  actions: {
    async load(requestId?: string) {
      this.loading = true;

      try {
        let parsedList;

        if (requestId) {
          const { data } = await Api.requestContent.get(requestId);

          if (!data || !data.requestContent) {
            return Promise.resolve();
          }

          parsedList = this.parseList([data.requestContent]);

          this.$patch({ list: parsedList });
          return Promise.resolve(parsedList);
        }

        const { data } = await Api.requestContent.list();

        parsedList = this.parseList(data.requestContent);

        this.$patch({ list: parsedList });
        return Promise.resolve(parsedList);
      } catch (e) {
        console.error('[RequestContent] Cannot load request content list');
        debug(e);

        return Promise.reject('Cannot load request content list');
      } finally {
        this.loading = false;
      }
    },
    parseList: (data: any) => {
      return data.map((item: any) => {
        return {
          id: item.id,
          slug: item.attributes.slug,
          name: item.attributes.name,
          message: item.attributes?.message,
          customId: item.attributes?.customId,
          requestLink: item?.links?.requestLink,
          collectionId: item?.relationships?.collection?.data?.id,
        };
      });
    },
  },
  getters: {},
});
